<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div v-if="!isLoading">
      <Layout1 v-if="onlineExhibition.template_id === 1" />
      <Layout2 v-if="onlineExhibition.template_id === 2" />
    </div>
  </div>
</template>

<script>
import Layout1 from "../../components/online_exhibition_layout/Layout1";
import Layout2 from "../../components/online_exhibition_layout/Layout2";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import {setMetaTags} from "@/util/Constants";

export default {
  components: {
    Layout1,
    Layout2,
    Loading
  },
  methods: {},
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      onlineExhibition: state => state.Article.onlineExhibition
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function () {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchChanged,
          this.allBranches,
          this.lang
      )
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    this.isLoading = true;
    await this.$store.dispatch('Article/onGetOnlineExhibitionsById', { id: this.$route.params.id, lang: this.lang });
    setMetaTags(document, window, this.onlineExhibition[`title_${this.lang}`], this.onlineExhibition[`title_${this.lang}`], this.onlineExhibition.cover_image)
    this.isLoading = false;
  },
  data: () => ({
    item: {
      layout: 2 // TODO :: change dynamic layout value
    },
    isLoading: false,
    items: [
      {
        text: "TCDC BANGKOK",
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "ONLINE EXHIBITION",
        href: "/:branch/service/resource-center/online-exhibition"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
</style>
